import React, { PropsWithChildren, ReactElement } from 'react';
import { RouteComponentProps } from '@reach/router';
import { Role_Enum } from 'generated/graphql';
import { useAuthContext } from 'components/authorization/AuthProvider';

// Roles that work with patients, and so can see the pages for their own account
// (e.g. their payment methods), including basic Providers who cannot see the admin
// pages. VansanityAdmins never hold cards or EHR subscriptions.
export const clinicalRoles = [
  Role_Enum.Provider,
  Role_Enum.Manager,
  Role_Enum.LocationAdmin,
];

type Props<TComponent extends ReactElement<TProps>, TProps = {}> = {
  component: TComponent;
} & RouteComponentProps<TProps>;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ClinicalRoute = <
  TComponent extends ReactElement<TProps>,
  TProps = {},
>({
  component,
  ...rest
}: PropsWithChildren<Props<TComponent>>): React.ReactElement<TComponent> => {
  const { authUser } = useAuthContext();

  if (!clinicalRoles.includes(authUser?.role)) {
    return <div />;
  }

  return (
    <div>
      {React.cloneElement(component, rest as RouteComponentProps<TProps>)}
    </div>
  );
};
